export const BILLING_REP_EMAIL = "billing@clipboardhealth.com";
export const SUPPORT_TELEPHONE = "408-837-0116";
export const SUPPORT_WEBFORM_URL = "https://support.clipboardhealth.com/hc/en-us/requests/new";

// eslint-disable-next-line no-restricted-syntax
export enum CbhSpecialistType {
  BILLING_SPECIALIST = "billingSpecialist",
  ACCOUNT_MANAGER = "accountManager",
}
